module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/d55e0c977385f080b82cffa2f80c3140.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_groups_expand.svg
// module id = 12dE
// module chunks = 1